module.exports = __webpack_public_path__ + "static/media/bird2.789d760a.jpg";